import { render, staticRenderFns } from "./success-password-form.vue?vue&type=template&id=587f636a"
import script from "./success-password-form.vue?vue&type=script&lang=js"
export * from "./success-password-form.vue?vue&type=script&lang=js"
import style0 from "./success-password-form.vue?vue&type=style&index=0&id=587f636a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports